import T from 'terrific';
import $ from 'jquery';
import { toggleContent } from '../../../../assets/js/utils/toggle';

/**
 * Basic Module description.
 */
T.Module.ProductList = T.createModule({
	_attributes: {
		moreLessContentToggleTarget: 'data-js-more-less-content-toggle-target',
		moreLessContentLayoutAdapter1Target: 'data-js-more-less-adapter1-toggle-target',
		moreLessContentLayoutAdapter2Target: 'data-js-more-less-adapter2-toggle-target',
	},
	_selectors: {
		moreLessContentToggle: '[data-js-more-less-content-toggle-trigger]',
	},
	_eventNames: {
		CLICK: 'click',
	},
	_stateClasses: {},

	start(resolve) {
		// this.$ctx will contain a jQuery reference to the root element in the DOM.
		this.$ctx = $(this._ctx);
		this.$ctx.find(this._selectors.moreLessContentToggle).on(this._eventNames.CLICK, this.moreLessToggle.bind(this));

		resolve();
	},

	sync() {
		// Called when start() method of all registered modules was called.
	},

	moreLessToggle(ev) {
		const $ctx = this.$ctx;
		const $el = $(ev.currentTarget);
		const target = $el.attr(this._attributes.moreLessContentToggleTarget);

		toggleContent($el, target, $ctx);

		const adapter1Target = $el.attr(this._attributes.moreLessContentLayoutAdapter1Target);
		$(adapter1Target).toggleClass('h-d-none');

		const adapter2Target = $el.attr(this._attributes.moreLessContentLayoutAdapter2Target);
		$(adapter2Target).toggleClass('h-d-none');
	},
});
